import { Checkbox } from "@mantine/core";
import { useHeldEmailSelectAll } from "../../../hooks/admin/useHeldEmailSelection";
import { HeldEmailSelectionModel } from "./heldEmailSelection";

interface Props {
  selection: HeldEmailSelectionModel;
}

export function HeldEmailQueueSelectAll({ selection }: Props) {
  const selected = useHeldEmailSelectAll(selection);
  return (
    <Checkbox
      aria-label="Select all actionable emails"
      checked={selected.all}
      indeterminate={selected.some}
      onChange={selected.change}
    />
  );
}
